<div class="main-content" id="ssp">
    <div class="card">
        <div class="card-header card-header-{{color}}-6">
            <h4>FET Item Report</h4>
        </div>
        <div class="card-body">
            <div class="row m-0 p-0">
                <div class="col-3 m-0 p-0">
                    <a class="btn btn-danger" (click)="exportPdf();">
                        <i *ngIf="!exportingPDF" class="fa fa-file-pdf-o"></i>
                        <svg *ngIf="exportingPDF" class="spinner" width="15px" height="15px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                        </svg>
                    </a>
                    <a class="btn btn-success" (click)="exportXls();">
                        <i *ngIf="!exportingXLS" class="fa fa-file-excel-o"></i>
                        <svg *ngIf="exportingXLS" class="spinner" width="15px" height="15px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                        </svg>
                    </a>
                </div>
                <div class="col-4 m-0 p-0 justify-content-center">
                    <mat-form-field appearance="outline" class="ml-1 p-0 m-0">
                        <mat-label>Search</mat-label>
                        <input matInput class="text-right" [formControl]="searchRef" [value]="" placeholder="Search for an item by ID, Description or Brand">
                    </mat-form-field>
                </div>
                <div class="col-2 m-0 p-0">
                    <mat-slide-toggle class="pl-2" (change)="filter()">Mismatched Only</mat-slide-toggle>
                </div>
                <div class="col-3 m-0 p-0">
                    <mat-paginator [pageSizeOptions]="items_per_page" [pageSize]="pagesizedefault"></mat-paginator>
                </div>
            </div>
            <div class="table-container">
                <table class="table-fixed table-bordered table-hover w-100 batch-table">
                    <thead>
                        <tr class="sticky">
                            <th class="text-center">Stockid</th>
                            <th class="text-center">Brand</th>
                            <th class="text-center">Description</th>
                            <th class="text-center">MFGPART</th>
                            <th class="text-center">FET (current)</th>
                            <th class="text-center">FET (atd)</th>
                            <th class="text-center">FET (fkl)</th>
                            <th class="text-center">FET (thub)</th>
                            <th></th>
                        </tr>
                    </thead>

                    <div class="row m-0 justify-content-center p-3" *ngIf="itemsloading">
                        <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                        </svg>
                    </div>
                    
                    <tbody *ngIf="allitems.length">
                         <tr class="invoice-row" *ngFor="let item of dataObs | async">
                            <td>{{item.stockid}}</td>
                            <td>{{item.name}}</td>
                            <td>{{item.description}}</td>
                            <td>{{item.mfgpart}}</td>
                            <td [ngClass]="{'warn-row': item.warn }">{{item.currentfet | currency}}</td>
                            <td [ngClass]="{'warn-row': item.warn }">{{item.fetatd | currency}}</td>
                            <td [ngClass]="{'warn-row': item.warn }">{{item.fetfkl | currency}}</td>
                            <td [ngClass]="{'warn-row': item.warn }">{{item.fetthub | currency}}</td>
                         </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="card-footer">
        </div>
    </div>
</div>
